import { Amplify } from '@aws-amplify/core';
import { generateClient } from 'aws-amplify/api';

Amplify.configure({
  API: {
    GraphQL: {
      endpoint: process.env.NEXT_PUBLIC_APPSYNC_API_URL,
      region: process.env.NEXT_PUBLIC_APPSYNC_API_REGION,
      defaultAuthMode: 'lambda',
      apiKey: process.env.NEXT_PUBLIC_APPSYNC_API_KEY
    }
  }
});

// https://aws.amazon.com/ru/blogs/mobile/announcing-aws-amplifys-graphql-api-cdk-construct-deploy-real-time-graphql-api-and-data-stack-on-aws/
export const client = generateClient();
